import { render, staticRenderFns } from "./EventReports.vue?vue&type=template&id=65c07007&"
import script from "./EventReports.vue?vue&type=script&lang=js&"
export * from "./EventReports.vue?vue&type=script&lang=js&"
import style0 from "./EventReports.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports